import { StoreItemEnum } from '@systemeio/digital-store-shared'
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum'
import { StoreItemWithTabType } from 'modules/stores/store/types/store-item-interface'

export function getTabFromItem(item: StoreItemWithTabType): StoreTabEnum {
  switch (item) {
    case StoreItemEnum.link:
      return StoreTabEnum.link
    case StoreItemEnum.optin:
      return StoreTabEnum.optin
    case StoreItemEnum.product:
      return StoreTabEnum.product
    default:
      throw new Error()
  }
}
